/**
 * Shared money formatting for the marketing module. Ad metrics store integer
 * cents; unlike CRM's `formatCents` (whole units), ad spend keeps two decimals
 * because per-click/per-lead costs are routinely sub-unit.
 *
 * Currency resolves per-record when the record carries one (e.g. conversion
 * events), otherwise from the deployment default (`DEFAULT_CURRENCY` via
 * `GET /api/features`) — never a hardcoded `$`.
 */

import { getDefaultCurrency } from '@/hooks/useDefaultCurrency'

export function formatMarketingCents(
  cents: number,
  currency?: string | null,
  opts?: { fractionDigits?: number },
): string {
  const code = currency || getDefaultCurrency()
  const digits = opts?.fractionDigits ?? 2
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(cents / 100)
  } catch {
    // Malformed currency code → RangeError; degrade to number + code.
    return new Intl.NumberFormat(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(cents / 100) + ' ' + code
  }
}
